export const getValuePlaceholder = (value) => {
  const s = Number(value)
  if (Math.abs(s) >= 1000) {
    return s.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
  return value
}
